import { getAccompanimentsSearchServiceList } from './accompaniments/accompanimentsSearch'
import { getAccompanimentsBookedServiceList } from './accompaniments/accompanimentsBookedServices'
import { getAccompanimentsHistoryList } from './accompaniments/accompanimentsHistory'
import { getProfessionalSelectionSearchServiceList } from './professionalSelection/professionalSelectionSearch'
import { getProfessionalSelectionHistoryServiceList } from './professionalSelection/professionalSelectionHistory'
import { getResidentsList } from '$services/nursingHome/residents'
import { createRecommendationService } from '$services/nursingHome/recommendation/recommendation.service'

export const accompanimentServices = {
  getAccompanimentsSearchServiceList,
  getAccompanimentsBookedServiceList,
  getAccompanimentsHistoryList,
}

export const professionalSelectionServices = {
  getProfessionalSelectionSearchServiceList,
  getProfessionalSelectionHistoryServiceList,
}

export const residentsServices = {
  getResidentsList,
}

export const recommendationServices = {
  createRecommendationService,
}



// WEBPACK FOOTER //
// ./src/services/nursingHome/index.ts